import { MapPin, Clock, Layers, Phone } from "lucide-react";
import { useSEO } from "@/hooks/useSEO";
import { SITE } from "@/data/content";
import { ContactForm } from "@/components/contact/ContactForm";
import { Reveal } from "@/components/shared/Reveal";
import { LineReveal } from "@/components/shared/Reveal";

const NEXT = [
  { Icon: Clock, t: "We review your enquiry", d: "A Wexoz specialist reads your requirement and the solution you selected." },
  { Icon: Layers, t: "Discovery conversation", d: "We discuss your operation, fleet, existing systems and objectives." },
  { Icon: MapPin, t: "Proposal and architecture", d: "You receive a recommended approach, technology options and next steps." },
];

export default function Contact() {
  useSEO({ title: "Contact Wexoz | Talk to a Transportation Technology Expert in Dubai", description: "Contact Wexoz Security & Surveillance LLC in Dubai to discuss fleet IoT, logistics automation, school transport, transport CCTV, AI or transportation technology consulting." });
  return (
    <section className="relative isolate overflow-hidden pt-[76px]">
      <div className="absolute inset-0 -z-10 grid-bg opacity-40 [mask-image:radial-gradient(ellipse_at_top_left,black_20%,transparent_70%)]" />
      <div className="wrap grid gap-14 py-20 lg:grid-cols-12 lg:py-28">
        <div className="lg:col-span-5">
          <div className="eyebrow">Contact</div>
          <LineReveal lines={["Let's talk about your", "transportation operation."]} delay={0.15} className="mt-6 text-4xl font-semibold leading-[1.05] sm:text-5xl lg:text-6xl" />
          <Reveal delay={0.5} className="mt-8 max-w-md text-slate-400 md:text-lg">Tell us what you run and what you need. Whether it is a single requirement or a complete transportation technology architecture, we will help you evaluate, design and implement the right solution.</Reveal>
          <Reveal delay={0.6} className="mt-10 card p-6">
            <div className="flex items-center gap-3 text-white"><MapPin className="h-5 w-5 text-cyan-400" /><span className="font-heading font-semibold">{SITE.name}</span></div>
            <p data-testid="contact-location" className="mt-2 pl-8 text-sm leading-relaxed text-slate-400">{SITE.address}</p>
            <div className="mt-5 flex items-start gap-3"><Phone className="mt-0.5 h-5 w-5 text-cyan-400" />
              <div className="flex flex-col gap-1">
                {SITE.phones.map((p) => (
                  <a key={p.tel} href={`tel:${p.tel}`} data-testid={`contact-phone-${p.tel}`} className="text-sm text-slate-300 transition-colors hover:text-cyan-400">{p.label}</a>
                ))}
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.7} className="mt-10">
            <div className="eyebrow !text-slate-500">What happens next</div>
            <ol className="mt-5 space-y-5">
              {NEXT.map(({ Icon, t, d }, i) => (
                <li key={t} className="flex gap-4">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-line bg-navy-800 text-cyan-400"><Icon className="h-4 w-4" /></span>
                  <div><div className="font-medium text-white">0{i + 1} — {t}</div><p className="mt-1 text-sm text-slate-400">{d}</p></div>
                </li>
              ))}
            </ol>
          </Reveal>
        </div>
        <Reveal delay={0.3} className="lg:col-span-7"><ContactForm /></Reveal>
      </div>
    </section>
  );
}
